<template>
  <div class="border-lightPrimaryTextColor dark:border-darkPrimaryTextColor border-b-[1px]" />
</template>
